/**
 * String 모듈 격자 — Vue state ↔ SolarString API (변환 없음, 필드명 1:1)
 *
 * | Vue data (나누기 UI) | 의미           | API 필드 |
 * |----------------------|----------------|----------|
 * | moduleColNum         | 가로(↔) 칸 수  | colNum   |
 * | moduleRowNum         | 세로(↕) 칸 수  | rowNum   |
 *
 * getModuleCellCorners: i ∈ [0, moduleRowNum), j ∈ [0, moduleColNum)
 */

/**
 * @param {number} moduleColNum
 * @param {number} moduleRowNum
 * @returns {{ rowNum: number, colNum: number }}
 */
export function moduleColRowToApiFields(moduleColNum, moduleRowNum) {
  return { colNum: moduleColNum, rowNum: moduleRowNum };
}

/**
 * @param {number|null|undefined} rowNum API 세로(↕) 칸 수
 * @param {number|null|undefined} colNum API 가로(↔) 칸 수
 * @returns {{ moduleColNum: number|null, moduleRowNum: number|null }}
 */
export function apiFieldsToModuleColRow(rowNum, colNum) {
  return {
    moduleColNum: colNum ?? null,
    moduleRowNum: rowNum ?? null
  };
}

/**
 * @param {object} vm — moduleColNum / moduleRowNum
 * @param {number|null|undefined} rowNum
 * @param {number|null|undefined} colNum
 */
export function applyApiFieldsToModuleColRow(vm, rowNum, colNum) {
  const { moduleColNum, moduleRowNum } = apiFieldsToModuleColRow(rowNum, colNum);
  if (moduleColNum != null && moduleColNum > 0) {
    vm.moduleColNum = moduleColNum;
  }
  if (moduleRowNum != null && moduleRowNum > 0) {
    vm.moduleRowNum = moduleRowNum;
  }
}
